import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import logo from "@/assets/logo.png";

interface CTASectionProps {
  user: any;
  onGetStarted: () => void;
}

export const CTASection = ({ user, onGetStarted }: CTASectionProps) => {
  return (
    <section className="relative py-20 md:py-32 overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 bg-gradient-to-t from-primary/5 via-background to-background" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[400px] md:w-[600px] h-[400px] md:h-[600px] bg-gradient-to-t from-accent/15 to-transparent rounded-full blur-[100px]" />

      <div className="container relative z-10 px-4">
        <div className="max-w-4xl mx-auto text-center space-y-8 md:space-y-10">
          {/* Logo with prosperity glow */}
          <div className="flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-accent/30 blur-3xl rounded-full scale-150" />
              <img src={logo} alt="KOSH" className="relative h-20 w-20 md:h-28 md:w-28 animate-float" />
            </div>
          </div>

          {/* Headline */}
          <div className="space-y-4">
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-balance px-2">
              Your Business Runs
              <br className="hidden sm:block" />
              <span className="text-gradient">Every Day.</span>
            </h2>
            <p className="text-lg md:text-xl text-muted-foreground max-w-xl mx-auto px-4">
              Shouldn't you know if it's working?
            </p>
          </div>

          {/* Stats reinforcement */}
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 text-sm md:text-base text-muted-foreground">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-foreground">1,000+</div>
              <div>Indian businesses</div>
            </div>
            <div className="w-px h-10 bg-border hidden md:block" />
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-foreground">60 sec</div>
              <div>daily close</div>
            </div>
            <div className="w-px h-10 bg-border hidden md:block" />
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-foreground">₹0</div>
              <div>to start</div>
            </div>
          </div>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center px-4">
            <Button 
              size="lg" 
              onClick={onGetStarted}
              className="group text-base md:text-lg h-14 md:h-16 px-10 md:px-12 rounded-full bg-gradient-to-r from-primary to-primary-dark hover:from-primary-dark hover:to-primary shadow-xl shadow-primary/30 hover:shadow-2xl hover:shadow-primary/40 transition-all duration-300 w-full sm:w-auto"
            >
              {user ? "Go to Dashboard" : "Start My Free Account"}
              <ArrowRight className="ml-2 h-5 w-5 md:h-6 md:w-6 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>

          {/* Final trust */}
          <p className="text-xs md:text-sm text-muted-foreground">
            No credit card required • Free forever plan • Cancel anytime
          </p>
        </div>
      </div>
    </section>
  );
};
